import React, {useState, Component, useEffect} from 'react'
import { Link } from 'react-router-dom'
import NoticeDetail from "./NoticeDetail";
import NoticeList from "./NoticeList";
import history from "../../route/history";


const Notice = props => {

  const prePage = (e) => {
    e.preventDefault();
    window.history.back()
  }

  return (
      <React.Fragment>
        <main>  
          <div id="contents">
            <div className='content-header'>
              <a onClick={prePage} className="page-prev">뒤로이동</a> {/* mobile */}
              <h2>공지사항</h2>
              <div className="breadcrumb">
                <span>Home</span><span>고객센터</span><em>공지사항</em>
              </div>
            </div>

            <div className="notice-tab">
              <ul className='nav-tab mt40'>
                  <li className="on"><Link title="공지사항" to="/notice">공지사항</Link></li>
                  <li><Link title="FAQ" to="/faq">FAQ</Link></li>
                  <li><Link title="문의하기" to="/question">문의하기</Link></li>
                  <li><Link title="자료실" to="/reference">자료실</Link></li>
                  <li><Link title="이용안내" to="/guide">이용안내</Link></li>
              </ul> 
            </div>
              {
                props.match.params.seq ?
                <NoticeDetail seq={props.match.params.seq} searchInfo={props.location.state}/>
                : <NoticeList search={props.location?.search} />
              }

              
          </div>
        </main>
      </React.Fragment>
  )
}
export default Notice

